"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = '00000000-0000-0000-0000-000000000000';
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/uuid/dist/nil.js
// module id = 732
// module chunks = 0